import { ReactElement, useEffect, useState } from 'react';
import { useSearchParams } from 'react-router';
import { isRequestType } from '../../../core/types';
import { useAppNavigate } from '../../../routes';
import { SupportFlow } from '../components';

export const SupportPage = (): ReactElement | null => {
  const [searchParams] = useSearchParams();
  const appNavigate = useAppNavigate();
  const [flowKey, setFlowKey] = useState(0);
  const type = searchParams.get('tipo') ?? '';
  const isValidType = isRequestType(type);

  useEffect(() => {
    if (!isValidType) {
      appNavigate('notFound', { replace: true });
    }
  }, [isValidType, appNavigate]);

  if (!isValidType) {
    return null;
  }

  return (
    <SupportFlow
      key={flowKey}
      type={type}
      onNewRequest={() => setFlowKey((previousKey) => previousKey + 1)}
    />
  );
};
